<template>
  <div class="pendant">
    <div class="tel item">
      <div class="tit">
        <i class="iconfont icondianhua"></i>
        <span>电话</span>
      </div>
      <div class="eject">
        <a :href="'tel://' + site.consumer_hotline">{{
          site.consumer_hotline
        }}</a>
      </div>
    </div>
    <div class="official item">
      <div class="tit">
        <i class="iconfont iconerweima"></i>
        <span>APP下载</span>
      </div>

      <div class="eject big">
        <img :src="site.app_qrcode" alt="" />
      </div>
    </div>
    <div class="official item">
      <div class="tit">
        <i class="iconfont iconerweima"></i>
        <span>公众号</span>
      </div>
      <div class="eject big">
        <img :src="site.wechat_qrcode" alt="" />
      </div>
    </div>
    <div class="official item">
      <div class="tit">
        <i class="iconfont iconerweima"></i>
        <span>抖音号</span>
      </div>
      <div class="eject big">
        <img src="https://zhongshengrunde.oss-cn-beijing.aliyuncs.com/v2/upload/default/0545ff3e19c4f8aeac49d0dfcc21aee4.jpg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['site'],
  data () {
    return {}
  }
}
</script>

<style>
/* 侧边客服 */
.pendant {
  position: fixed;
  bottom: 20%;
  right: -150px;
  z-index: 20;
}
.pendant .item {
  min-width: 200px;
  padding: 15px;
  background: rgba(0,0,0,.7);
  border-radius: 10px 0 0 10px;
  color: #fff;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
  transition: all 0.4s ease;
  position: relative;
  box-shadow: 0px 5px 13px #00000054;
  transform: translateX(0px);
}
.pendant .item:hover {
  background-color: #4e80ff;
  transform: translateX(-150px);
}
.pendant .item i {
  font-size: 34px;
}
.pendant .item .eject {
  min-width: 147px;
  padding-left: 10px;
  min-height: 100%;
  color: #fff;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pendant .item .eject.big img {
  width: 120px;
  height: 120px;
}
.tit {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 480px) {
  .pendant {
    top: 40%;
    display: none;
  }
  .pendant .item {
    padding: 10px;
  }
  .pendant .item i {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/pendant.vue